import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

import WeeklySkeleton from '../skeleton/ScheduleSkeleton';

import moment from 'moment';

const WeeklyCalendarUsersRow = (props) => {
  const {
    weekDays,
    scheduleEvents,
    user,
    filterSelection,
    UserRow,
    EventTile,
  } = props;

  const loadingScheduleData = scheduleEvents === undefined;

  const userFilterCheck = filterSelection.filter?.user?.optionSelectedData?.filter;

  if (!loadingScheduleData) {
    if (userFilterCheck) {
      const shouldBeFiltered = userFilterCheck(user, scheduleEvents, weekDays);
      if (!shouldBeFiltered) {
        return;
      }
    }
  }

  return (
    <Box
      sx={{
        'display': 'flex',
        'minHeight': 64,
        'borderBottom': '1px solid #ccc',
      }}
    >
      <Box
        sx={{
          'minWidth': 220,
          'maxWidth': 220,
          'borderRight': '1px solid #ccc',
        }}
      >
        <UserRow
          user={user}
        />
      </Box>
      {
        loadingScheduleData &&
        <WeeklySkeleton weekDays={weekDays} />
      }
      {
        !loadingScheduleData &&
        weekDays.map((day, colIdx) => {
          const momentDate = moment(day);
          const momentDay = momentDate.format('YYYY-MM-DD');
          const eventsForDay = scheduleEvents?.[momentDay] || [];
          const today = moment().startOf('day');

          return (
            <Box
              key={colIdx}
              sx={{
                width: `calc((100% - 220px) / 7)`,
                px: 0.5,
                py: 0.5,
                borderRight: colIdx < weekDays.length - 1 ? '1px solid #ccc' : 'none',
                backgroundColor: momentDate.isSame(today, 'day') ? '#f8fbff' : 'transparent',
              }}
            >
              {
                eventsForDay.map((event, index) => {
                  const filterEventCheck = filterSelection.filter?.event?.optionSelectedData?.filter;

                  if (filterEventCheck) {
                    const shouldBeFiltered = filterEventCheck(user, event);
                    if (!shouldBeFiltered) {
                      return;
                    }
                  }

                  return (
                    <EventTile
                      key={index}
                      event={event}
                    />
                  );
                })
              }
            </Box>
          );
        })
      }
    </Box>
  );
};

WeeklyCalendarUsersRow.propTypes = {
  weekDays: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.object,
  ])).isRequired,
  scheduleEvents: PropTypes.any,
  UserRow: PropTypes.elementType.isRequired,
  user: PropTypes.object.isRequired,
  EventTile: PropTypes.elementType.isRequired,
  filterSelection: PropTypes.object.isRequired,
};

export default WeeklyCalendarUsersRow;
